import * as React from 'react';

import { IDocument, IPage, IPlaceHolder, IDragInfo } from '../../../../../../../infrastructure/interfaces';
import PageEditor from '../../../common/PageEditor';
import PagePlaceholder from '../../../common/PagePlaceholder';

export interface IPageLayoutProps {
  page: IPage;
  second: boolean;
  handleDrop(index: number, data: IPlaceHolder, dragInfo: IDragInfo): void;
  removeProduct(data: any, index: number): void;
  document: IDocument | null;
  isEditor: Boolean;
}

export interface IPageLayoutState { }

export default class PageLayout extends React.Component<IPageLayoutProps, IPageLayoutState> {
  constructor(props: IPageLayoutProps) {
    super(props);
  }

  render() {
    return (this.props.page.placeholders.map((p, i) => {
      return (
        this.props.isEditor
        ? <PageEditor
            accepts={p.accepts}
            lastDroppedItem={p}
            onDrop={(data: any, type: any) => this.props.handleDrop(i, data, type)}
            removeProduct={this.props.removeProduct}
            index={i}
            key={i}
            page={this.props.page}
            document={this.props.document}
            layout="Bulletin"
          />
        : (
            <div
              key={this.props.page.number}
              className={`Bulletin right crop-page-view-drop isDropped catalog-product type2`}
              data-pagenumber={this.props.page.number}
            >
              <PagePlaceholder
                removeProduct={this.props.removeProduct}
                index={i}
                model={p}
                isEditorView={false}
                pageNumber={this.props.page.number}
                document={this.props.document}
              />
            </div>
          )
        );
    }));
  }
}



// WEBPACK FOOTER //
// ./src/components/Editor/components/CropPageView/Bulletin/Components/PageLayout/PageLayout.tsx